import styled from "styled-components/macro";

export const Filters = styled.div`
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 630px) {
        flex-direction: column;
    }
`;
